import React from 'react';
import { 
  Cookie 
} from '@mui/icons-material';
import { Button } from '@mui/material';

import FabButton from "@components/input/buttons/FabButton";

interface Props {
  disabled?: boolean;
  width?: number;
  label?: string;
  onClick: () => void;
}

export default function CookieButton({ 
  disabled = false,
  width,
  label = "",
  onClick 
}: Props) {

  if (label === "") {
    return (
      <FabButton
        disabled={disabled} 
        onClick={onClick}>
        <Cookie />
      </FabButton>
    );
  } else {
    return (
      <Button 
        disabled={disabled} 
        onClick={onClick} 
        style={width ? { width } : {}}
        variant="contained" color="primary">
        <Cookie />&nbsp;{ label }
      </Button>
    );
  }
}
